import styled from 'styled-components';
import { font } from '../globals/fonts';
import { gray0, gray7, gray2, gray6, gray5 } from '../globals/colors';

export var DataCard_Root = styled.div.withConfig({ displayName: "DataCardstyle__DataCard_Root", componentId: "sc-ag7o50-0" })(["background:", ";"],
gray0);


export var DataCard_Header = styled.h1.withConfig({ displayName: "DataCardstyle__DataCard_Header", componentId: "sc-ag7o50-1" })(["font-size:20px;color:", ";font-family:", ";padding:12px;padding-left:16px;border-bottom:1px solid ", ";align-self:center;margin:0;svg{color:", ";}"],

gray7,
font.lighter,


gray2,




gray6);



/** @param {React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>} props> */
var dataCard_EmptyStatefn = function dataCard_EmptyStatefn(props) {return {
    children: props.children || 'No information available'
  };};

export var DataCard_EmptyState = styled.div.attrs(dataCard_EmptyStatefn).withConfig({ displayName: "DataCardstyle__DataCard_EmptyState", componentId: "sc-ag7o50-2" })(["margin:2.5rem 0;text-align:center;font-size:1.25rem;color:", ";font-family:", ";width:100%;"],



gray5,
font.medium);
//# sourceMappingURL=DataCard.style.js.map